import { Grid, Paper } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { useContext } from "react";
import RegistrationLoader from "./RegistrationLoader";
import { Context } from "../../states/Store";
import ErrorNotice from "./ErrorNotice";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "40%",
    maxWidth: "400px",
    height: "auto",
    animation: "load 1.5s",
    paddingBottom: "2rem",

    [theme.breakpoints.down('lg')]: {
      width: "80%",
      marginTop: '1rem',
      marginBottom: '1rem',
    },

    [theme.breakpoints.down('sm')]: {
      width: "90%",
    },

    "& .textContainer": {
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },

    "& .separator": {
      width: "50px",
      height: "2px",
      background: "#5c5b5b",
      margin: "0 auto",
      marginBottom: "1.2rem",
      borderRadius: "5px",
    },
  },
  logo: {
    [theme.breakpoints.down('md')]: {
      width: "200px",
    }
  },
  logoIcon: {
    width: "236px",
    height: "47px",
    paddingBottom: "5px"
  }
}));

function RegistrationContainer(props) {
  const classes = useStyles();
  const [state] = useContext(Context);

  return <>
    {state.loader && <RegistrationLoader />}
    {!state.loader && (
      <>
      {props.app === "365" ?
        <img
          className={classes.logo}
          alt="Aprovall 360"
          src={"../assets/logo_360.svg"}
        />
        : <img
          className={classes.logoIcon}
          alt="Aprovall"
          src={props.app === "portal" ? "../assets/logo-portal.svg" : "../assets/logo_icon.png"}
        />}

        {/* Error Approval */}
        {(props.app === "365" || props.app === "portal") && props.errorType !== null &&
          <ErrorNotice
              errorType={props.errorType}
              appUrl={props.appUrl}
              app={props.app}
          />
        }

        {/* Content */}
        {(props.app === "365" || props.app === "portal") ? props.children :
          <Paper className={props.app !== "365" && classes.root} elevation={3}>
            <Grid justifyContent="center" alignItems="center" container spacing={0}>
              <Grid style={{ textAlign: "center" }} item xs={12}>
              </Grid>
              <Grid item xs={12}>
                {props.children}
              </Grid>
            </Grid>
          </Paper>
        }
      </>
    )}
  </>;
}

export default RegistrationContainer;
